<template>
  <div>
    <b-dropdown v-model="value.segment" aria-role="list" class="mb-2">
          <button  :class="['button', 'is-primary', size, size == 'is-small' ? 'narrow': 'wide']" type="button" slot="trigger" style="text-align:left;">
              <template v-if="value.segment == 0" :class="{'narrow': size == 'is-small', 'wide': size == 'is-large' }">
                    <b-icon style="width: 10%;  margin-right: 10%;" class=" is-pulled-left" icon="airplane-takeoff"></b-icon>
                    <div style="width: 80%;">
                         <p>
                          Departure Time
                         </p>
                    </div>
              </template>
              <template v-else :class="{'narrow': size == 'is-small', 'wide': size == 'is-large' }">
                    <b-icon style="width: 10%;  margin-right: 10%;" class=" is-pulled-left" icon="airplane-takeoff"></b-icon>
                    <div style="width: 80%;">
                         <p>
                          Arrival Time
                         </p>
                    </div>


              </template>
              <b-icon icon="menu-down"></b-icon>
          </button>
          <b-dropdown-item :value="0" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="airplane-takeoff"></b-icon>
                  <div class="media-content">
                       <p>
                        Departure Time
                       </p>
                  </div>
              </div>
          </b-dropdown-item>
          <b-dropdown-item :value="1" aria-role="listitem">
              <div class="media">
                  <b-icon class="media-left" icon="airplane-landing"></b-icon>
                  <div class="media-content">
                      <p>
                       Arrival Time
                      </p>
                  </div>
              </div>
          </b-dropdown-item>
      </b-dropdown>

    <p class="is-size-7"> {{ $helpers.miltTimeConvert(value.range[0]) + ' - ' + $helpers.miltTimeConvert(value.range[1]) }}</p>
    <b-field :class="[size == 'is-small' ? 'narrow': 'wide']">
         <b-slider v-model="value.range"  position="is-bottom" :custom-formatter="val => $helpers.miltTimeConvert(val) " type="is-teal" :size="size" :min="0" :max="24" lazy />
     </b-field>
  </div>
</template>

<script>
  export default {
    name: 'FlightTimeSelection',
    data() {
        return {
        }
    },
    props: {
      value: {},
      size: {
        type: String,
        default: 'is-small'
      }
    },
    computed: {
    },
    methods: {
      handleInput (val) {
        // console.log(val)
        this.value = val
        this.$emit('input', this.value)
      }
    },
    watch:{
      value: function(){
        this.$emit('input', this.value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .narrow {
    width: 150px;
  }
</style>
